<template>
  <div class="wap-footer">
    <img class="logo" src="@/assets/imgs/common/1.png" />
    <div style="margin-top:.5rem"></div>
    <template v-for="(item,index) in dataList">
      <div style="padding-bottom: 0.4rem;border-bottom: 0.02rem solid rgba(255,255,255,0.0800);margin-bottom: 0.4rem">
        <div class="footer-ul flex-sp">
          <span @click="to_page(item.path)">{{item.name}}</span>
          <template v-if="item.children">
            <img @click="btn_show(index)" v-if="!item.show" class="icon-ight" src="@/assets/imgs/wap/open1.png" />
            <img @click="btn_show(index)" v-if="item.show" class="icon-ight" src="@/assets/imgs/wap/close1.png" />
          </template>
        </div>

        <div v-show="item.show" style="margin-top: 0.2rem">
         <div class="footer-li" @click="to_page(items.path)" v-for="items in item.children">{{items.name}}</div>
        </div>
      </div>
    </template>

    <div class="footer-code flex">
      <img class="img1" src="@/assets/imgs/common/2.png" />
      <div class="sp1">
        <p>联系我们</p>
        <p style="margin-top: 0.6rem">023-6229-6708</p>
      </div>
    </div>
    <div class="footer-sp2">Copyright ©JDST 2022. All rights reserved   </div>
    <a class="footer-sp3" href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2020033111号-1</a>
    <a  class="footer-sp3" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002005080" target="_blank">
      <img src="@/assets/imgs/common/hui.png" style="margin-right: 10px;height: 0.32rem" />公安备案号51019002005080</a>
  </div>
</template>

<script>
  export default {
    name: 'wapfooters',
    data(){
      return{
        dataList:[
          {
            name:"解决方案",
            show:true,
            path:"/solution",
            children:[{
              name:"行业挑战",
              path:"/solution?index=index1"
            },{
              name:"方案优势",
              path:"/solution?index=index2"
            },{
              name:"方案价值",
              path:"/solution?index=index3"
            }]
          },
          {
            name:"产品与服务",
            show:false,
            path:"/product",
            children:[{
              name:"预应力工程全数量检测系统",
              path:"/product?index=1",
            },{
              name:"锚下预应力检测系统",
              path:"/product?index=2",
            },{
              name:"预应力锚索基础试验系统",
              path:"/product?index=3",
            }
              ,{
                name:"智能拉拔系统",
                path:"/product?index=4",
              }
              ,{
                name:"远程监测系统",
                path:"/product?index=5",
              }]
          },
          {
            name:"技术创新",
            show:false,
            path:"/technological",
          },
          {
            name:"典型案例",
            show:false,
            path:"/case",
            children:[{
              name:"高速公路",
              path:"/case?index=4",
            },{
              name:"软岩隧道",
              path:"/case?index=1",
            },{
              name:"铁路桥梁",
              path:"/case?index=2",
            }
              ,{
                name:"特殊桥梁",
                path:"/case?index=3",
              }
              ,{
                name:"边坡工程",
                path:"/case?index=5",
              }   ,{
                name:"基坑工程",
                path:"/case?index=6",
              }]
          },
          // {
          //   name:"新闻中心",
          //   show:false,
          //   path:"/news",
          // },
          {
            name:"关于交达",
            show:false,
            path:"/inRegard"
          },
          {
            name:"联系我们",
            show:false,
            path:"/contactUs",
          },
        ]
      }
    },
    mounted() {
    },
    methods: {
      to_page(path){
        this.$router.push({
          path:path
        });
        window.location.reload()
      },
      btn_show(index){
        this.dataList[index].show=!this.dataList[index].show
      }
    },
  }
</script>
<style>
  body{
    font-size: 0.24rem;
  }
</style>
<style scoped>
  .wap-footer{
    width: 100%;
    background-color: #19203B;
    padding: 0.4rem 0.6rem;
    box-sizing: border-box;
  }
  .wap-footer .logo{
    width: 2.6rem;
  }

  .footer-ul{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }

  .icon-ight{
    width: 0.36rem;
    object-fit: contain;
  }

  .footer-li{
    font-size: 0.28rem;
    margin-top: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #F2F2F2;
  }

  .footer-code{
    margin-top: 0.4rem;
  }
  .footer-code .img1{
    width: 1.6rem;
    height: 1.6rem;
  }

  .footer-code .sp1{
    margin-left: .2rem;
    font-size: 0.36rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }

  .footer-sp2{
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #F0F0F0;
    display: block;
    margin-top: 0.4rem;
    text-align: center;
  }
  .footer-sp3{
    font-size: 0.2rem;
    text-decoration:none;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #F0F0F0;
    display: block;
    margin-top: 0.1rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/wap/footer.vue